// External assets

// Types
import { DisaggregatedMetric, MetricPanelProps } from "../../services/types";

// Utils
import { getSortedMetrics, getSvgMap } from "../../utils/dashboardUtils";

// Components
import MetricCard from "../metrics/MetricCard";

const AccessibilityMetrics = ({ indicators, categorizedData, tab, geoDetails, geoTag, selectionActive }: MetricPanelProps) => {   
    const sortedMetrics = getSortedMetrics(tab, categorizedData);
    console.log("accessibility data:", sortedMetrics);

    if (!indicators || indicators.length === 0) {
        return <div className="flex items-center justify-center text-color-cai-dashboard">No metrics available for {tab}.</div>;
    }

    // Define metrics for order
    const a: DisaggregatedMetric[] = sortedMetrics[0];

    return (
        <>
            <div className="grid grid-cols-2 gap-4 place-items-start">
                {a?.map(metric => (
                    <MetricCard
                        key={metric.id}
                        metric={metric}
                        width="w-full"
                        svg={getSvgMap(metric.id)}
                        disaggData={indicators}
                        geoDetails={geoDetails}
                        geoTag={geoTag}
                        selectionActive={selectionActive}
                    />
                ))}
            </div>
        </>
    );
}

export default AccessibilityMetrics;